import { render } from "./UploadFile.vue?vue&type=template&id=d534551c&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=d534551c&scoped=true&lang=css"

import exportComponent from "C:\\projects\\epd-cnmp-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d534551c"]])

export default __exports__